import { current } from "@otto-ec/global-resources/navigation";

/**
 *
 *
 */
export function useHistoryTracking(): {
  getInitialTabFromUrl: (tabs: HTMLElement[]) => number | null;
  updateUrlForTab: (tabs: HTMLElement[], index: number) => void;
  setupHistoryListener: (tabs: HTMLElement[], selectTab: (index: number) => void) => () => void;
} {
  /**
 *
 *
 */
  function getInitialTabFromUrl(tabs: HTMLElement[]): number | null {
    if (!window.location.hash) return null;

    const hash = window.location.hash.substring(1); /*         */

    const tabIndex = tabs.findIndex((tab) => {
      const anchor = tab.querySelector("a[href]") as HTMLAnchorElement | null;
      if (!anchor?.href) return false;

      /*                                                */
      const hrefHash = anchor.href.includes("#") ? anchor.href.split("#")[1] : "";
      return hrefHash === hash;
    });

    return tabIndex >= 0 ? tabIndex : null;
  }

  /**
 *
 *
 */
  function updateUrlForTab(tabs: HTMLElement[], index: number): void {
    if (index < 0 || index >= tabs.length) return;

    const tab = tabs[index];
    const anchor = tab.querySelector("a[href]") as HTMLAnchorElement | null;

    if (anchor?.href) {
      /*                     */
      const hrefHash = anchor.href.includes("#") ? `#${anchor.href.split("#")[1]}` : "";
      if (hrefHash) {
        history.pushState(null, "", hrefHash);
      }
    }
  }

  /**
 *
 */
  function setupHistoryListener(
    tabs: HTMLElement[],
    selectTab: (index: number) => void,
  ): () => void {
    const handleHashChange = (): void => {
      const tabIndex = getInitialTabFromUrl(tabs);
      if (tabIndex !== null) {
        selectTab(tabIndex);
      }
    };

    const unsubscribe = current.subscribe(() => {
      handleHashChange();
    });

    return unsubscribe;
  }

  return {
    getInitialTabFromUrl,
    updateUrlForTab,
    setupHistoryListener,
  };
}
